<template>
    <BlockUI :blocked="loadingData">
        <Card dir="rtl" id="SCHEDULE">
            <template #header>

                <div style="width: 100%;" class="p-p-2 ">
                    <div class="p-m-1 p-pt-3 noScreen">
                        <h1 class="" style="text-align: center">
                            {{ getTeacherName() }}
                        </h1>
                    </div>

                    <div v-if="showReport" class="">
                        <h1 style="text-align: center">
                            דווח - {{ scheduleTeacherLength }} / {{studyTeacherLength}}

                        </h1>
                    </div>
                </div>
            </template>
            <template class="p-p-0" #content>
                <tbody class="p-grid p-p-0">

                <Header add-class="teacher" class="p-col-12"/>
                <row-schedule
                        :deleteMode="deleteMode"
                        :isMultipleAllow="isMultipleAllow"
                        :weekSelected="weekSelected"
                        :showReport="showReport"
                        :loading="loadingData"
                        :rowScheduleValue="scheduleTeacher && scheduleTeacher[lesson.id]"
                        :studyTeacher="studyTeacher && studyTeacher[lesson.id]"
                        v-for="lesson in lessonTime"
                        :lesson="lesson"
                        @deleteSchedule="deleteSchedule"
                        :teacher="teacher"/>
                </tbody>
            </template>
        </Card>
    </BlockUI>

</template>

<script>
import Header from "@/views/Schedule/Header";
import RowSchedule from "@/views/Schedule/ScheduleTeacher/RowSchedule";
import {getScheduleByTeacher, getWeekStudyByTeacher, getWeekTrackingByTeacher} from "@/views/Schedule/Schedule.js";
import {mapState} from "vuex";
import TableBody from "../../../../primevue/datatable/TableBody";
import {getTeacherFullName} from "@/utils/parseObj";

export default {
    name: "ScheduleTeacherTable",
    props: {
        teacher: {
            type: String,
            default: null
        },
        weekSelected: {
            type: Object,
            default: null
        },
        showReport: {
            type: Boolean,
            default: false
        },
        deleteMode: {  
            type: Boolean,
            default: false
        },
        isMultipleAllow: {
            type: Boolean,
            default: false
        },
    },
    components: {
        TableBody,
        RowSchedule,
        Header
    },
    created() {
        this.initSchedule()
    },
    methods: {
        deleteSchedule(event){
            this.initSchedule()
            // console.log("this.scheduleTeacher", this.scheduleTeacher)
            // this.scheduleTeacher.findIndex(s =>{
            //     console.log("eventevent",event)
            //     console.log("ssss",s)
            //     return s._id.day === event.day &&
            //         s._id.grade === event.grade &&
            //         s._id.lesson === event.lesson
            // })
        },
        getTeacherName() {
            return getTeacherFullName(this.teacher)
        },
        async initSchedule() {
            try {
                if (this.teacher) {
                    this.loadingData = true
                    const {lessonGroup, lessonLength} = await getScheduleByTeacher(this.teacher)
                    this.scheduleTeacher = lessonGroup
                    this.scheduleTeacherLength = lessonLength
                    this.loadingData = false

                }
            } catch (e) {
            }
        },
        async initStudyTeacher() {
            try {
                if (this.weekSelected) {
                    this.loadingData = true
                    const {studyGroup, studyLength} = await getWeekStudyByTeacher(this.teacher, this.weekSelected)
                    this.studyTeacher = studyGroup
                    this.studyTeacherLength = studyLength
                    this.loadingData = false

                }
            } catch (e) {
            }
        },
    },
    watch: {
        teacher() {
            this.initSchedule()
            this.initStudyTeacher()
        },
        weekSelected() {
            this.initStudyTeacher()
        }
    },
    data() {
        return {
            loadingData: false,
            scheduleTeacher: null,
            scheduleTeacherLength: null,
            studyTeacher: null,
            studyTeacherLength: null,
        }
    },
    computed: {
        getScheduleCount() {

            return this.scheduleTeacherLength
        },
        ...mapState(["lessonTime", "subjectLesson"]),
    },
}
</script>

<style scoped>
@media screen {
    .noScreen {
        display: none;
    }
}

@media print {
    .noPrint {
        display: none;
    }
}

>>> .p-card-content {
    padding: 0 !important;
}

</style>